import { apiClient, API_CONFIG } from '../../core';
import type {
  LC_AuthenticateIn,
  LC_AuthenticateOut,
  LC_PasswordRecoveryIn,
  LC_PasswordRecoveryOut,
  LC_PasswordUpdateIn,
  LC_PasswordUpdateOut,
  LC_GetAccountInfoOut,
  LC_LinkAccountIn,
  LC_LinkAccountOut,
  User,
} from './auth.types';
import type { ApiResponse } from '../../shared';
import { mapLoginResponseToUser, extractTokenInfo } from './auth.mapper';


export class AuthService {
  async login(credentials: LC_AuthenticateIn): Promise<ApiResponse<LC_AuthenticateOut>> {
    return apiClient.post<LC_AuthenticateOut>(
      API_CONFIG.ENDPOINTS.AUTHENTICATION.LOGIN,
      credentials,
      { authRequired: false, skipUnauthorizedHandler: true },
    );
  }

  async recoverPassword(
    data: LC_PasswordRecoveryIn,
  ): Promise<ApiResponse<LC_PasswordRecoveryOut>> {
    return apiClient.post<LC_PasswordRecoveryOut>(
      API_CONFIG.ENDPOINTS.AUTHENTICATION.RECOVER_PASSWORD,
      data,
      { authRequired: false, skipUnauthorizedHandler: true },
    );
  }

  async updatePassword(
    data: LC_PasswordUpdateIn,
  ): Promise<ApiResponse<LC_PasswordUpdateOut>> {
    return apiClient.post<LC_PasswordUpdateOut>(
      API_CONFIG.ENDPOINTS.AUTHENTICATION.UPDATE_PASSWORD,
      data,
      { authRequired: false, skipUnauthorizedHandler: true },
    );
  }

  async checkPendingSSO(): Promise<ApiResponse<LC_AuthenticateOut>> {
    return apiClient.get<LC_AuthenticateOut>(
      API_CONFIG.ENDPOINTS.AUTHENTICATION.SSO_CHECK_PENDING,
      { authRequired: false, skipUnauthorizedHandler: true, credentials: 'include' },
    );
  }

  async getAccountInfo(): Promise<ApiResponse<LC_GetAccountInfoOut>> {
    return apiClient.get<LC_GetAccountInfoOut>(
      API_CONFIG.ENDPOINTS.AUTHENTICATION.SSO_ACCOUNT_INFO,
    );
  }

  async linkAccount(data: LC_LinkAccountIn): Promise<ApiResponse<LC_LinkAccountOut>> {
    return apiClient.post<LC_LinkAccountOut>(
      API_CONFIG.ENDPOINTS.AUTHENTICATION.SSO_LINK_ACCOUNT,
      data,
    );
  }

  mapLoginResponseToUser(response: LC_AuthenticateOut): User {
    return mapLoginResponseToUser(response);
  }
  extractTokenInfo(response: LC_AuthenticateOut) {
    return extractTokenInfo(response);
  }

  isTokenExpired(tokenExpiry: Date): boolean {
    return new Date() >= tokenExpiry;
  }

  parseTokenExpiry(expiresAt: string): Date {
    return new Date(expiresAt);
  }
}

export const authService = new AuthService();
